<template>
  <div id="app" class="soft-ui-bg">
    <!-- 移动端路由：直接显示组件，不显示PC头部和底部 -->
    <router-view v-if="isMobileRoute" />
    
    <!-- PC端路由：显示PC头部和底部 -->
    <div class="content-container" v-else>
      <app-header></app-header>
      <router-view/>
      <div class="footer-container" v-if="showFooter">
        <div class="footer-copyright">
          <i class="far fa-copyright"></i> 2007-{{ currentYear }} ETComm 益体康（北京）科技有限公司 京ICP备09007401号 京公网安备11010802027358号
        </div>
      </div>  
    </div>
  </div>
</template>

<script>
import AppHeader from './components/AppHeader'

export default {
  name: 'App',
  components: {
    AppHeader
  },
  data() {
    return {
      currentYear: new Date().getFullYear()
    }
  },
  computed: {
    isMobileRoute() {
      return this.$route.path.startsWith('/m/') || this.$route.path === '/report';
    },
    showFooter() {
      return this.$route.path !== '/login' && this.$route.path !== '/report';
    }
  }
}
</script>

<style>
#app {
  font-family: "Microsoft YaHei UI","PingFang SC", system-ui, -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  min-height: 100vh;
}

.content-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;
  padding-top: 20px;
}

.footer-container {
  padding-bottom: 30px;
}

html,body{
  height: 100%;
  margin: 0;
  padding: 0;
}
body{
  width:100%;
  position:relative;
}
.el-menu--horizontal.user-submenu{
  width: 350px;
}
.el-menu--horizontal.user-submenu ul{
    width: 124px;
    padding: 0 10px;
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/App.vue